import React from 'react';
import { MessageSquarePlus, TriangleAlert } from 'lucide-react';
import Fenetre from './Fenetre';
import FormulaireRetour from './FormulaireRetour';

/* ═══════════════════════════════════════════════════════════════════════════
   « SIGNALER UN PROBLÈME » / « COMMENTAIRES ET SUGGESTIONS » — EN SURIMPRESSION

   Les deux formulaires vivaient au bas de la page d'aide : y aller, c'était
   quitter l'écran dont on voulait justement parler. Ils s'ouvrent désormais
   au premier plan, au-dessus de la page en cours — comme les candidatures
   coach et mentor — et la page jointe au message est bien celle d'où l'on
   écrit.
   ═══════════════════════════════════════════════════════════════════════════ */

const ENTETES = {
  probleme: { titre: 'Signaler un problème', icone: TriangleAlert },
  suggestion: { titre: 'Commentaires et suggestions', icone: MessageSquarePlus },
};

export default function FenetreRetour({ nature, onClose }) {
  const entete = ENTETES[nature] || ENTETES.probleme;
  return (
    <Fenetre titre={entete.titre} icone={entete.icone} onClose={onClose}>
      <FormulaireRetour nature={nature} onFermer={onClose} />
    </Fenetre>
  );
}
